import * as React from 'react';

import type { IconProps } from '../types';

const StatusStar = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 16, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        aria-hidden="true"
        {...props}
      >
        <path
          fill="currentColor"
          d="M7.74637 1.78228C7.82197 1.53091 8.17791 1.53091 8.25351 1.78228L9.59165 6.23135C9.61725 6.31646 9.68385 6.38305 9.76896 6.40865L14.218 7.74679C14.4694 7.8224 14.4694 8.17833 14.218 8.25394L9.76896 9.59208C9.68385 9.61768 9.61725 9.68427 9.59165 9.76939L8.25351 14.2185C8.17791 14.4698 7.82197 14.4698 7.74637 14.2185L6.40822 9.76939C6.38262 9.68427 6.31603 9.61768 6.23092 9.59208L1.78185 8.25394C1.53048 8.17833 1.53048 7.8224 1.78185 7.74679L6.23092 6.40865C6.31603 6.38305 6.38262 6.31646 6.40822 6.23135L7.74637 1.78228Z"
        />
      </svg>
    );
  }
);

StatusStar.displayName = 'StatusStar';

export { StatusStar };
